import * as React from 'react';
import { composer } from '../../../component-decorators/composer';
import { Text, Heading, Box } from 'wix-style-react';
export var SearchResultHeaderContent = composer()
    .withTranslation()
    .compose(function (_a) {
    var query = _a.query, t = _a.t;
    return (React.createElement(Box, { direction: "vertical", align: "left", dataHook: "search-result-header-content" },
        React.createElement(Text, { size: "medium", weight: "bold", dataHook: "search-result-header-content-subtitle" }, t('searchResultHeaderContent.searchResult')),
        React.createElement(Heading, { appearance: 'H1', dataHook: "search-result-header-content-title" }, t(query))));
});
//# sourceMappingURL=search-result-header-content.js.map